module.exports = __webpack_public_path__ + "static/project-8-0e052b2f65726db6d515cd6505f80866.jpg";